module.exports = __webpack_public_path__ + "img/woman_1_icon.f0f5ddac.png";